<template>
    <ModalWrapper v-model="dialog" transition="dialog-center-transition" :subtitle="$t('check_the_columns')">
        <template v-slot:activator="{props}">
            <v-btn
                color="primary"
                variant="text"
                icon="mdi-circle-edit-outline"
                v-bind="props"
                @click="dialog = true"
            />
        </template>
        <template v-slot:title>
            {{ $t('configure_table_with_reservations') }}
        </template>
        <template v-slot:content>
            <template v-for="item in value" :key="item.value">
                <v-checkbox
                    v-if="item.value !== 'id'"
                    v-model="item.show"
                    :label="item.title"
                    density="compact"
                    hide-details
                />
            </template>
        </template>
        <template v-slot:btns>
            <v-btn data-cy="save" :loading="isLoading" :disabled="isLoading" variant="flat" @click="save">
                {{ $t('save') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    import {clone} from '@/utils/helpers'

    @Component({
        components: {},
    })
    export class ReservationsTableOptionsModal extends Vue {
        @Prop() tableColumns

        dialog = false
        isLoading = false

        value = []

        mounted() {
            this.value = clone(this.tableColumns)
        }

        async save() {
            this.isLoading = true
            try {
                const columns = []
                this.value.forEach(item => {
                    if (!item.show) columns.push(item.value)
                })
                await this.$api.reservationsTableOptions.post({userId: this.userId, columns})
                this.$emit('change', columns)
                this.dialog = false
                // eslint-disable-next-line no-empty
            } catch (e) {}
            this.isLoading = false
        }

        get userId() {
            return authStore.person.personId
        }
    }

    export default ReservationsTableOptionsModal
</script>
